import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'
import globals from '#utilities/js/ea/globals.js'

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: async (
    form,
    event
  ) => {
    try {
      const res = await fromEvent(form, event)

      if (res) {
        const buttonClose = one('button[name="cancel"]', form)
        const { action } = form
        const body = new FormData()

        if (buttonClose) {
          buttonClose.click()
        }

        for (const input of all('input[type="hidden"]', form)) {
          body.append(input.name, input.value)
        }

        globals.ea_link(action + '?' + `${new URLSearchParams(body)}`, '', null)
      }
    } catch (e) {
      console.error(e)
    }
  }
})

export default (
  form
) => {
  onSubmit.listen(form)
}